import { render, staticRenderFns } from "./MasterTruckLumpsumAdd.vue?vue&type=template&id=bc69fb58&scoped=true"
import script from "./MasterTruckLumpsumAdd.vue?vue&type=script&lang=js"
export * from "./MasterTruckLumpsumAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc69fb58",
  null
  
)

export default component.exports